

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Edit, Trash } from "lucide-react";
import { useNavigate } from "react-router-dom";
import Apiurl from "./../../environment/Apiurl";

function AddPurchasePharmacy() {
  const navigate = useNavigate();
  const [getMedicineMaster, setGetMedicineMaster] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [isLoadingMedicines, setIsLoadingMedicines] = useState(false);
  const [purchaseSaved, setPurchaseSaved] = useState(false);
  const [purchaseId, setPurchaseId] = useState(null);
  const [isCredit, setIsCredit] = useState(false);
  const [isAutoRound, setIsAutoRound] = useState(false);
  const [editRowId, setEditRowId] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [counter, setCounter] = useState(1); // will generate 001, 002, 003...
  const [medicineData, setMedicineData] = useState({
    hsn_code: "",
    medicine_id: "",
    medicine_name: "",
    manufacturer: "",
    medicine_type: "",
    unit_pack: "",
    quantity: "",
    free_qty: "",
    purchase_price: "",
    mrp: "",
    tax: "",
    total: "",
    batch_no: "",
    expiry_date: "",
    discount_per_tablet: "",
    gst_percentage: "",
  });
  const [addData, setAddData] = useState({
    category: "",
    hsn_code: "",
    medicine_name: "",
    medicine_type: "",
    manufacturer: "",
    free_qty: "",
    notes: "",
  });
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentData, setPaymentData] = useState({
    paid_date: new Date().toISOString().split("T")[0],
    pay_type: "",
    paid_amount: "",
  });
  const [paymentTableData, setPaymentTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [showHsnDropdown, setShowHsnDropdown] = useState(false);
  const [filteredHsnCodes, setFilteredHsnCodes] = useState([]);
  const [purchaseInfo, setPurchaseInfo] = useState({
    purchase_date: new Date().toISOString().split("T")[0],
    invoice_number: "",
    supplier_id: "",
    supplier_name: "",
    supplier_mobile: "",
    credit_days: "",
    gst_amount: 0,
    sub_total: 0,
    discount_percentage: 0,
    discount_value: 0,
    net_total: 0,
    paid: 0,
    balance: 0,
    round_off: 0,
    notes: "",
    created_by: "",
    manual_date: "",
  });

  const fetchMedicineMaster = async () => {
    try {
      setIsLoadingMedicines(true);
      const response = await axios.get(`${Apiurl}/medicine_master`);
      setGetMedicineMaster(response.data || []);
    } catch (error) {
      console.log("Error fetching medicines", error.message);
    } finally {
      setIsLoadingMedicines(false);
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await axios.get(`${Apiurl}/supplier_pharmacy`);
      setSuppliers(response.data || []);
    } catch (error) {
      console.log("Error fetching suppliers", error.message);
    }
  };

  useEffect(() => {
    fetchMedicineMaster();
    fetchSuppliers();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "expiry_date") {
      const regex = /^(\d{0,2})(\/)?(\d{0,4})?$/;
      if (regex.test(value)) {
        let formattedValue = value;
        if (value.length === 2 && !value.includes("/")) {
          formattedValue = `${value}/`;
        }
        setMedicineData((prev) => ({
          ...prev,
          [name]: formattedValue,
        }));
      }
    } else {
      setMedicineData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    if (name === "hsn_code" || name === "medicine_name") {
      const filtered = getMedicineMaster.filter(
        (med) =>
          med.hsn_code?.toLowerCase().includes(value.toLowerCase()) ||
          med.medicine_name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredHsnCodes(filtered);
      setShowHsnDropdown(true);
    }
  };

  const handleAddInputChange = (e) => {
    const { name, value } = e.target;
    setAddData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);


  const handlePurchasedate = async (e) => {
    const { value } = e.target;

    if (!value) {
      setPurchaseInfo((prev) => ({
        ...prev,
        manual_date: "",
        // purchase_date: "", // Removed as per your request
      }));
      return;
    }

    const dateObj = new Date(value);
    if (isNaN(dateObj)) return;

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = String(dateObj.getFullYear()).slice(-2);

    try {
      const response = await axios.get(`${Apiurl}/generate_ggrm`, {
        params: {
          manual_date: "", // Use `params` for query string in GET requests
        }
      });

      const data = response.data;
      console.log("The data was manual", response);

      if (data.manual_date) {
        const formatted = `${day}/${month}/${year}-${data.manual_date}`;

        setPurchaseInfo((prev) => ({
          ...prev,
          manual_date: formatted,
          // purchase_date: value, // Removed as per your request
        }));
      } else {
        console.error("Invalid response from server", data);
      }
    } catch (error) {
      console.error("Failed to generate serial number", error);
    }
  };



  const handlePurchaseInfoChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (name === "credit") {
      setIsCredit(checked);
      setPurchaseInfo((prev) => ({
        ...prev,
        credit_days: checked ? prev.credit_days || "30" : "",
      }));
    } else if (name === "auto_round") {
      setIsAutoRound(checked);
      if (checked) {
        const base_total =
          parseFloat(purchaseInfo.sub_total) -
          parseFloat(purchaseInfo.discount_value) +
          parseFloat(purchaseInfo.gst_amount);
        const round_off = Math.round(base_total) - base_total;
        setPurchaseInfo((prev) => ({
          ...prev,
          round_off: round_off.toFixed(2),
        }));
      } else {
        setPurchaseInfo((prev) => ({
          ...prev,
          round_off: "0",
        }));
      }
    } else {
      setPurchaseInfo((prev) => ({
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handlePaymentInputChange = (e) => {
    const { name, value } = e.target;
    setPaymentData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSupplierSelect = (e) => {
    const supplierId = e.target.value;
    const selectedSupplier = suppliers.find(
      (s) => s.supplier_id === supplierId
    );
    if (selectedSupplier) {
      setPurchaseInfo((prev) => ({
        ...prev,
        supplier_id: selectedSupplier.supplier_id,
        supplier_name: selectedSupplier.supplier_name,
        supplier_mobile: selectedSupplier.mobile,
      }));
    }
  };

  const handleHsnFocus = () => {
    if (medicineData.hsn_code) {
      const filtered = getMedicineMaster.filter((med) =>
        med.hsn_code
          ?.toLowerCase()
          .includes(medicineData.hsn_code.toLowerCase())
      );
      setFilteredHsnCodes(filtered);
    } else {
      setFilteredHsnCodes(getMedicineMaster);
    }
    setShowHsnDropdown(true);
  };

  const handleHsnBlur = () => {
    setTimeout(() => {
      setShowHsnDropdown(false);
    }, 200);
  };

  const selectHsnCode = (medicine) => {
    if (!medicine) return;

    setMedicineData({
      hsn_code: medicine.hsn_code || "",
      medicine_id: medicine._id || "",
      medicine_name: medicine.medicine_name || "",
      manufacturer: medicine.manufacturer || "",
      medicine_type: medicine.medicine_type || "",
      unit_pack: medicine.unit_pack || "",
      quantity: "",
      free_qty: medicine.free_qty || "",
      purchase_price: medicine.purchase_rate || medicine.purchase_price || "",
      mrp: medicine.mrp || medicine.purchase_mrp || "",
      tax: "",
      total: "",
      batch_no: "",
      expiry_date: "",
      discount_per_tablet: "",
      gst_percentage: "",
    });
    setShowHsnDropdown(false);
  };

  const calculateTotal = () => {
    const quantity = parseFloat(medicineData.quantity) || 0;
    const purchase_price = parseFloat(medicineData.purchase_price) || 0;
    const gst_percentage = parseFloat(medicineData.gst_percentage) || 0;
    const discount_per_tablet =
      parseFloat(medicineData.discount_per_tablet) || 0;

    const subtotal = quantity * purchase_price;
    const discount_amount = (subtotal * discount_per_tablet) / 100;
    const discounted_subtotal = subtotal - discount_amount;
    const tax = (discounted_subtotal * gst_percentage) / 100;

    setMedicineData((prev) => ({
      ...prev,
      tax: tax.toFixed(2),
      total: (discounted_subtotal + tax).toFixed(2),
    }));
  };

  useEffect(() => {
    if (
      medicineData.quantity &&
      medicineData.purchase_price &&
      medicineData.gst_percentage
    ) {
      calculateTotal();
    }
  }, [
    medicineData.quantity,
    medicineData.purchase_price,
    medicineData.gst_percentage,
    medicineData.discount_per_tablet,
  ]);

  useEffect(() => {
    const sub_total = tableData.reduce((sum, item) => {
      const quantity = parseFloat(item.quantity) || 0;
      const purchase_price = parseFloat(item.purchase_price) || 0;
      const discount_per_tablet = parseFloat(item.discount_per_tablet) || 0;
      const subtotal = quantity * purchase_price;
      const discount_amount = (subtotal * discount_per_tablet) / 100;
      return sum + (subtotal - discount_amount);
    }, 0);
    const discount_value =
      (sub_total * (parseFloat(purchaseInfo.discount_percentage) || 0)) / 100;
    const gst_amount = tableData.reduce(
      (sum, item) => sum + (parseFloat(item.tax) || 0),
      0
    );
    const base_total = sub_total - discount_value + gst_amount;
    let round_off = parseFloat(purchaseInfo.round_off) || 0;
    if (isAutoRound) {
      round_off = Math.round(base_total) - base_total;
    }
    const net_total = base_total + round_off;
    const total_paid = paymentTableData.reduce(
      (sum, item) => sum + (parseFloat(item.paid_amount) || 0),
      0
    );

    setPurchaseInfo((prev) => ({
      ...prev,
      apply_gst: true,
      sub_total: sub_total.toFixed(2),
      discount_value: discount_value.toFixed(2),
      gst_amount: gst_amount.toFixed(2),
      round_off: round_off.toFixed(2),
      net_total: net_total.toFixed(2),
      paid: total_paid.toFixed(2),
      balance: (net_total - total_paid).toFixed(2),
    }));
  }, [tableData, purchaseInfo.discount_percentage, paymentTableData, isAutoRound, purchaseInfo.round_off]);

  const openAddModal = () => {
    setShowAddModal(true);
  };

  const closeAddModal = () => {
    setShowAddModal(false);
    setAddData({
      category: "",
      hsn_code: "",
      medicine_name: "",
      medicine_type: "",
      manufacturer: "",
      free_qty: "",
      notes: "",
    });
  };

  const handleAddSubmit = async (e) => {
    e.preventDefault();
    if (
      !addData.category ||
      !addData.hsn_code ||
      !addData.medicine_name ||
      !addData.medicine_type
    ) {
      alert("Please fill all required fields");
      return;
    }

    setLoading(true);
    try {
      const newMedicine = {
        category: addData.category,
        hsn_code: addData.hsn_code,
        medicine_name: addData.medicine_name,
        medicine_type: addData.medicine_type,
        manufacturer: addData.manufacturer,
        free_qty: addData.free_qty,
        notes: addData.notes,
      };

      const response = await axios.post(`${Apiurl}/medicine_master`, newMedicine);
      setMedicineData((prev) => ({
        ...prev,
        hsn_code: response.data.hsn_code,
        medicine_id: response.data._id,
        medicine_name: response.data.medicine_name,
        medicine_type: response.data.medicine_type,
        manufacturer: response.data.manufacturer,
        free_qty: response.data.free_qty,
      }));
      await fetchMedicineMaster();
      closeAddModal();
    } catch (error) {
      console.error("Error adding new medicine:", error);
      alert(`Failed to add medicine: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const addToTable = async () => {
    if (
      !medicineData.hsn_code ||
      !medicineData.unit_pack ||
      !medicineData.medicine_name ||
      !medicineData.batch_no ||
      !medicineData.quantity ||
      !medicineData.purchase_price ||
      !medicineData.mrp ||
      !medicineData.gst_percentage
    ) {
      alert("Please fill all required fields");
      return;
    }

    if (parseFloat(medicineData.quantity) < 0 || parseFloat(medicineData.free_qty) < 0) {
      alert("Quantity and Free Quantity cannot be negative");
      return;
    }

    const existingItem = tableData.find(
      (item) =>
        item.hsn_code === medicineData.hsn_code &&
        item.batch_no === medicineData.batch_no &&
        item.id !== editRowId
    );

    let newRows = [];

    if (existingItem && medicineData.discount_per_tablet === "100") {
      const newRow = {
        ...medicineData,
        id: editRowId || Date.now(),
        discount_per_tablet: 100,
        tax: "0.00",
        total: "0.00",
      };
      newRows = [newRow];
    } else {
      const newRow = {
        ...medicineData,
        id: editRowId || Date.now(),
        discount_per_tablet: medicineData.discount_per_tablet || 0,
      };
      newRows = [newRow];
    }

    if (editRowId) {
      setTableData(
        tableData.map((item) => (item.id === editRowId ? newRows[0] : item))
      );
      setEditRowId(null);
    } else {
      setTableData([...tableData, ...newRows]);
    }

    const existingMedicine = getMedicineMaster.find(
      (med) => med.hsn_code === medicineData.hsn_code
    );

    if (!existingMedicine) {
      try {
        const newMedicine = {
          medicine_name: medicineData.medicine_name,
          manufacturer: medicineData.manufacturer,
          medicine_type: medicineData.medicine_type,
          hsn_code: medicineData.hsn_code,
          unit_pack: medicineData.unit_pack,
          free_qty: medicineData.free_qty,
          purchase_price: medicineData.purchase_price,
          mrp: medicineData.mrp,
        };

        const response = await axios.post(
          `${Apiurl}/medicine_master`,
          newMedicine
        );
        setMedicineData((prev) => ({
          ...prev,
          medicine_id: response.data._id,
        }));
        await fetchMedicineMaster();
      } catch (error) {
        console.log("Error adding new medicine", error.message);
        setTableData(
          tableData.filter((item) => !newRows.some((row) => row.id === item.id))
        );
        alert("Failed to add new medicine to master");
        return;
      }
    }

    setMedicineData({
      hsn_code: "",
      medicine_id: "",
      medicine_name: "",
      manufacturer: "",
      medicine_type: "",
      unit_pack: "",
      quantity: "",
      free_qty: "",
      purchase_price: "",
      mrp: "",
      tax: "",
      total: "",
      batch_no: "",
      expiry_date: "",
      discount_per_tablet: "",
      gst_percentage: "",
    });
  };

  const editTableRow = (item) => {
    setMedicineData({
      hsn_code: item.hsn_code,
      medicine_id: item.medicine_id,
      medicine_name: item.medicine_name,
      manufacturer: item.manufacturer,
      medicine_type: item.medicine_type,
      unit_pack: item.unit_pack,
      quantity: item.quantity,
      free_qty: item.free_qty,
      purchase_price: item.purchase_price,
      mrp: item.mrp,
      tax: item.tax,
      total: item.total,
      batch_no: item.batch_no,
      expiry_date: item.expiry_date,
      discount_per_tablet: item.discount_per_tablet,
      gst_percentage: item.gst_percentage,
    });
    setEditRowId(item.id);
  };

  const removeFromTable = (id) => {
    setTableData(tableData.filter((item) => item.id !== id));
    if (editRowId === id) {
      setEditRowId(null);
      setMedicineData({
        hsn_code: "",
        medicine_id: "",
        medicine_name: "",
        manufacturer: "",
        medicine_type: "",
        unit_pack: "",
        quantity: "",
        free_qty: "",
        purchase_price: "",
        mrp: "",
        tax: "",
        total: "",
        batch_no: "",
        expiry_date: "",
        discount_per_tablet: "",
        gst_percentage: "",
      });
    }
  };

  const handleTableRowChange = (id, field, value) => {
    setTableData(
      tableData.map((item) => {
        if (item.id === id) {
          const updatedItem = { ...item, [field]: value };

          if (
            [
              "quantity",
              "purchase_price",
              "gst_percentage",
              "discount_per_tablet",
            ].includes(field)
          ) {
            const quantity = parseFloat(updatedItem.quantity) || 0;
            const purchase_price = parseFloat(updatedItem.purchase_price) || 0;
            const gst_percentage = parseFloat(updatedItem.gst_percentage) || 0;
            const discount_per_tablet =
              parseFloat(updatedItem.discount_per_tablet) || 0;

            const subtotal = quantity * purchase_price;
            const discount_amount = (subtotal * discount_per_tablet) / 100;
            const discounted_subtotal = subtotal - discount_amount;
            const tax = (discounted_subtotal * gst_percentage) / 100;

            updatedItem.tax = tax.toFixed(2);
            updatedItem.total = (discounted_subtotal + tax).toFixed(2);
          }

          return updatedItem;
        }
        return item;
      })
    );
  };

  const addPaymentToTable = () => {
    if (
      !paymentData.paid_date ||
      !paymentData.pay_type ||
      !paymentData.paid_amount
    ) {
      alert("Please fill all payment fields");
      return;
    }

    const newPayment = {
      id: Date.now(),
      paid_date: paymentData.paid_date,
      pay_type: paymentData.pay_type,
      paid_amount: parseFloat(paymentData.paid_amount).toFixed(2),
    };

    setPaymentTableData([...paymentTableData, newPayment]);
    setPaymentData({
      paid_date: new Date().toISOString().split("T")[0],
      pay_type: "",
      paid_amount: "",
    });
  };

  const removePaymentFromTable = (id) => {
    setPaymentTableData(paymentTableData.filter((item) => item.id !== id));
  };

  const openModal = async () => {
    if (!purchaseInfo.invoice_number || !purchaseInfo.supplier_id) {
      alert("Please fill Invoice Number and select Supplier");
      return;
    }
    if (tableData.length === 0) {
      alert("Please add at least one medicine");
      return;
    }

    const saved = await handleSavePurchase();
    if (saved) {
      setPaymentModal(true);
    } else {
      alert("Failed to save purchase. Please try again.");
    }
  };

  const closeModal = () => {
    setPaymentModal(false);
    setPaymentData({
      paid_date: new Date().toISOString().split("T")[0],
      pay_type: "",
      paid_amount: "",
    });
  };

  const handleSavePurchase = async () => {
    if (!purchaseInfo.invoice_number || !purchaseInfo.supplier_id) {
      alert("Please fill Invoice Number and select Supplier");
      return false;
    }

    
    if (tableData.length === 0) {
      alert("Please add at least one medicine");
      return false;
    }

    if (!purchaseInfo.purchase_date) {
      alert("Please select a purchase date");
      return false;
    }

    try {
      const purchase_list = tableData.map((item) => ({
        invoice_number: item.invoice_number || purchaseInfo.invoice_number,
        medicine_id: item.medicine_id,
        batch_no: item.batch_no,
        unit_pack: item.unit_pack,
        expiry_date: item.expiry_date,
        quantity: parseFloat(item.quantity) || 0,
        free_qty: parseFloat(item.free_qty) || 0,
        purchase_price: item.purchase_price,
        mrp: item.mrp,
        gst_percentage: item.gst_percentage,
        tax: item.tax,
        total: item.total,
        discount_per_tablet: item.discount_per_tablet || 0,
        manual_date: item.manual_date
      }));

      const payload = {
        ...purchaseInfo,
        purchase_date: purchaseInfo.purchase_date || new Date().toISOString().split("T")[0], // Fallback to current date
        purchase_list,
      };

      console.log("Saving purchase with payload:", payload); // Debug log

      let response;
      if (purchaseSaved && purchaseId) {
        response = await axios.put(
          `${Apiurl}/purchase_pharmacy/${purchaseId}`,
          payload
        );
      } else {
        response = await axios.post(`${Apiurl}/purchase_pharmacy`, payload);
        setPurchaseId(response.data.purchase._id);
      }

      setPurchaseSaved(true);
      return true;
    } catch (error) {
      console.error("Error saving purchase:", error);
      alert(
        `Failed to save purchase: ${error.response?.data?.message || error.message}`
      );
      return false;
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    if (paymentTableData.length === 0) {
      alert("Please add at least one payment");
      return;
    }

    try {
      const purchaseCheck = await axios.get(
        `${Apiurl}/purchase_pharmacy?invoice_number=${purchaseInfo.invoice_number}`
      );
      if (!purchaseCheck.data || purchaseCheck.data.length === 0) {
        throw new Error(
          `Purchase not found for invoice_number: ${purchaseInfo.invoice_number}`
        );
      }

      const payload = {
        invoice_number: purchaseInfo.invoice_number,
        payments: paymentTableData.map((payment) => ({
          paid_date: payment.paid_date,
          pay_type: payment.pay_type,
          paid_amount: payment.paid_amount,
        })),
      };

      const response = await axios.post(
        `${Apiurl}/purchase_payment_pharmacy`,
        payload
      );
      alert("Payments saved successfully!");
      closeModal();
    } catch (error) {
      console.error("Error saving payments:", error);
      alert(
        `Failed to save payments: ${error.response?.data?.message || error.message}`
      );
    }
  };

  const handleSubmit = async () => {
    const saved = await handleSavePurchase();
    if (saved) {
      alert(`Purchase saved successfully! - GRNMM No:${purchaseInfo.manual_date}`);
      navigate("/pharmacy/purchase-pharmacy");
    }
  };

  const handleClearOverAll = () => {
    setMedicineData({
      hsn_code: "",
      medicine_id: "",
      medicine_name: "",
      manufacturer: "",
      medicine_type: "",
      unit_pack: "",
      quantity: "",
      free_qty: "",
      purchase_price: "",
      mrp: "",
      tax: "",
      total: "",
      batch_no: "",
      expiry_date: "",
      discount_per_tablet: "",
      gst_percentage: "",
    });
    setPurchaseInfo({
      purchase_date: new Date().toISOString().split("T")[0],
      invoice_number: "",
      supplier_id: "",
      supplier_name: "",
      supplier_mobile: "",
      credit_days: "",
      gst_amount: 0,
      sub_total: 0,
      discount_percentage: 0,
      discount_value: 0,
      net_total: 0,
      paid: 0,
      balance: 0,
      round_off: 0,
      notes: "",
      created_by: "",
      manual_date: "",
    });
    setTableData([]);
    setPaymentTableData([]);
    setPurchaseSaved(false);
    setPurchaseId(null);
    setIsCredit(false);
    setIsAutoRound(false);
    setEditRowId(null);
    setCounter(1); // Reset counter
  };

  return (
    <>
      <div className="p-2 " style={{ overflow: "hidden" }}>
        <div className="row">
          <div className="col-lg-9">
            <div className="card p-1">
              <div className="mb-3">
                <button
                  type="button"
                  className="btn btn-sm btn-primary"
                  onClick={openAddModal}
                >
                  Add Medicine +
                </button>
              </div>

              <div className="row g-2">
                <div className="col-lg-2">
                  <label htmlFor="hsn_code" className="form-label fw-bold">
                    HSN Code
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      type="text"
                      className="form-control"
                      id="hsn_code"
                      name="hsn_code"
                      value={medicineData.hsn_code}
                      onChange={handleInputChange}
                      onFocus={handleHsnFocus}
                      onBlur={handleHsnBlur}
                      placeholder="Enter HSN Code"
                      required
                      autoComplete="off"
                    />
                    {showHsnDropdown && (
                      <div
                        style={{
                          position: "absolute",
                          zIndex: 1000,
                          width: "100%",
                          maxHeight: "200px",
                          overflowY: "auto",
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                          marginTop: "5px",
                        }}
                      >
                        {isLoadingMedicines ? (
                          <div style={{ padding: "8px", textAlign: "center" }}>
                            Loading...
                          </div>
                        ) : filteredHsnCodes.length > 0 ? (
                          filteredHsnCodes.map((medicine, index) => (
                            <div
                              key={index}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                borderBottom: "1px solid #eee",
                                backgroundColor: "#fff",
                              }}
                              onMouseDown={(e) => {
                                e.preventDefault();
                                selectHsnCode(medicine);
                              }}
                            >
                              {medicine.hsn_code} - {medicine.medicine_name}
                              <div style={{ fontSize: "0.8rem", color: "#666" }}>
                                {medicine.manufacturer}
                              </div>
                            </div>
                          ))
                        ) : (
                          <div
                            style={{
                              padding: "8px",
                              color: "#666",
                              fontStyle: "italic",
                            }}
                          >
                            No matching HSN codes found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-lg-2">
                  <label htmlFor="medicine_name" className="form-label fw-bold">
                    Medicine Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="medicine_name"
                    name="medicine_name"
                    value={medicineData.medicine_name}
                    onChange={handleInputChange}
                    placeholder="Enter Medicine Name"
                    required
                  />
                </div>

                <div className="col-lg-2">
                  <label htmlFor="batch_no" className="form-label fw-bold">
                    Batch No
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="batch_no"
                    name="batch_no"
                    value={medicineData.batch_no}
                    onChange={handleInputChange}
                    placeholder="Enter Batch No"
                    required
                  />
                </div>

                <div className="col-lg-2">
                  <label htmlFor="expiry_date" className="form-label fw-bold">
                    Exp Date
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="expiry_date"
                    name="expiry_date"
                    value={medicineData.expiry_date}
                    onChange={handleInputChange}
                    placeholder="MM/YYYY"
                    required
                    maxLength={7}
                  />
                </div>

                <div className="col-lg-2">
                  <label htmlFor="medicine_type" className="form-label fw-bold">
                    Medicine Type
                  </label>
                  <select
                    className="form-control"
                    id="medicine_type"
                    name="medicine_type"
                    value={medicineData.medicine_type}
                    onChange={handleInputChange}
                    required
                  >
                    <option value="">Select Type</option>
                    <option value="Tablet">Tablet</option>
                    <option value="Capsule">Capsule</option>
                    <option value="Syrup">Syrup</option>
                    <option value="Injection">Injection</option>
                    <option value="Powder">Powder</option>
                    <option value="Sachet">Sachet</option>
                    <option value="Cream">Cream</option>
                    <option value="Ointment">Ointment</option>
                    <option value="Gel">Gel</option>
                    <option value="Drops">Drops</option>
                    <option value="Inhaler">Inhaler</option>
                    <option value="Suppository">Suppository</option>
                    <option value="Suspension">Suspension</option>
                    <option value="Spray">Spray</option>
                    <option value="Lotion">Lotion</option>
                    <option value="Solution">Solution</option>
                    <option value="Patch">Patch</option>
                    <option value="Dispersible Tablet">Dispersible Tablet</option>
                    <option value="Chewable Tablet">Chewable Tablet</option>
                    <option value="IV Fluid">IV Fluid</option>
                  </select>
                </div>

                <div className="col-lg-2">
                  <label htmlFor="manufacturer" className="form-label fw-bold">
                    Manufacturer
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="manufacturer"
                    name="manufacturer"
                    value={medicineData.manufacturer}
                    onChange={handleInputChange}
                    placeholder="Enter Manufacturer"
                    required
                  />
                </div>

                <div className="col-lg-1">
                  <label htmlFor="unit_pack" className="form-label fw-bold">
                    Unit
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="unit_pack"
                    name="unit_pack"
                    value={medicineData.unit_pack}
                    onChange={handleInputChange}
                    placeholder="Unit"
                    required
                  />
                </div>

                <div className="col-lg-1">
                  <label htmlFor="quantity" className="form-label fw-bold">
                    Qty
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="quantity"
                    name="quantity"
                    value={medicineData.quantity}
                    onChange={handleInputChange}
                    placeholder="Quantity"
                    required
                  />
                </div>

                <div className="col-lg-1">
                  <label htmlFor="free_qty" className="form-label fw-bold">
                    Free
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="free_qty"
                    name="free_qty"
                    value={medicineData.free_qty}
                    onChange={handleInputChange}
                    placeholder="Free Qty"
                  />
                </div>

                <div className="col-lg-2">
                  <label htmlFor="purchase_price" className="form-label fw-bold">
                    PRT
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="purchase_price"
                    name="purchase_price"
                    value={medicineData.purchase_price}
                    onChange={handleInputChange}
                    placeholder="Price"
                    required
                  />
                </div>

                <div className="col-lg-2">
                  <label htmlFor="mrp" className="form-label fw-bold">
                    MRP
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="mrp"
                    name="mrp"
                    value={medicineData.mrp}
                    onChange={handleInputChange}
                    placeholder="MRP"
                    required
                  />
                </div>

                <div className="col-lg-1">
                  <label htmlFor="discount_per_tablet" className="form-label fw-bold">
                    Dis
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="discount_per_tablet"
                    name="discount_per_tablet"
                    value={medicineData.discount_per_tablet}
                    onChange={handleInputChange}
                    placeholder="Dis"
                  />
                </div>

                <div className="col-lg-1">
                  <label htmlFor="gst_percentage" className="form-label fw-bold">
                    GST(%)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="gst_percentage"
                    name="gst_percentage"
                    value={medicineData.gst_percentage}
                    onChange={handleInputChange}
                    placeholder="GST"
                    required
                  />
                </div>

                <div className="col-lg-2">
                  <label htmlFor="total" className="form-label fw-bold">
                    Total
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="total"
                    name="total"
                    value={medicineData.total}
                    readOnly
                    placeholder="Total"
                  />
                </div>

                <div className="col-lg-1 d-flex align-items-end">
                  <button
                    className="btn btn-sm mb-4 btn-success w-75"
                    onClick={addToTable}
                    disabled={isLoadingMedicines}
                  >
                    {editRowId ? "Update" : "+"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card card-body py-1">
              <div className="row">
                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="purchase_date"
                    value={purchaseInfo.purchase_date}
                    onChange={handlePurchaseInfoChange}
                  />
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">Invoice</label>
                  <input
                    type="text"
                    className="form-control"
                    name="invoice_number"
                    value={purchaseInfo.invoice_number}
                    onChange={handlePurchaseInfoChange}
                    placeholder="Invoice Number"
                    required
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">GRNMM</label>
                  <input
                    type="date"
                    className="form-control"
                    name="manual_date"
                    onChange={handlePurchasedate}
                  />
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">GRNMM No</label>
                  <input
                    type="text"
                    className="form-control"
                    name="manual_date_display"
                    value={purchaseInfo.manual_date}
                    readOnly
                  />
                </div>
              </div>


              {/* <div className="row">
                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">GRNMM</label>
                  <input
                    type="date"
                    className="form-control"
                    name="manual_date"
                    value={purchaseInfo.purchase_date}
                    onChange={handlePurchasedate}
                  />
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">GRNMM Display</label>
                  <input
                    type="text"
                    className="form-control"
                    name="manual_date_display"
                    value={purchaseInfo.manual_date}
                    readOnly
                  />
                </div>
              </div> */}

              <div className="row">
                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">Supplier</label>
                  <select
                    className="form-control"
                    name="supplier_id"
                    value={purchaseInfo.supplier_id}
                    onChange={handleSupplierSelect}
                    required
                  >
                    <option value="">Select Supplier</option>
                    {suppliers.map((supplier) => (
                      <option
                        key={supplier.supplier_id}
                        value={supplier.supplier_id}
                      >
                        {supplier.supplier_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="col-lg-6">
                  <label className="col-form-label fw-bold">Mobile</label>
                  <input
                    type="text"
                    className="form-control"
                    name="supplier_mobile"
                    value={purchaseInfo.supplier_mobile}
                    onChange={handlePurchaseInfoChange}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-lg-9">
            <div className="card mt-2 card-body border-0 shadow-sm">
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead className="table-light">
                    <tr>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff" }}>
                        S.No
                      </th>
                      <th
                        style={{
                          backgroundColor: "#01AEBE",
                          color: "#fff",
                          width: "20%",
                        }}
                      >
                        Product
                      </th>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff" }}>
                        Exp Date
                      </th>
                      <th
                        style={{
                          backgroundColor: "#01AEBE",
                          color: "#fff",
                          width: "10%",
                        }}
                      >
                        Qty
                      </th>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff", width: "10%", }}>
                        Free
                      </th>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff", width: "15%", }}>
                        PRT
                      </th>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff" }}>
                        Dis
                      </th>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff" }}>
                        Tax
                      </th>
                      <th style={{ backgroundColor: "#01AEBE", color: "#fff" }}>
                        Total
                      </th>
                      <th
                        className="text-center"
                        style={{ backgroundColor: "#01AEBE", color: "#fff" }}
                      >
                        Action
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {tableData.map((item, index) => (
                      <tr key={item.id}>
                        <td>{index + 1}</td>
                        <td>
                          {item.medicine_name}
                          <div style={{ fontSize: "12px", color: "#666" }}>
                            {item.hsn_code} / {item.batch_no}
                          </div>
                        </td>
                        <td>
                          <input
                            type="text"
                            name="expiry_date"
                            className="form-control"
                            value={item.expiry_date}
                            onChange={(e) =>
                              handleTableRowChange(
                                item.id,
                                "expiry_date",
                                e.target.value
                              )
                            }
                            placeholder="MM/YYYY"
                            maxLength={7}
                          />
                        </td>
                        <td className="text-center">
                          <input
                            type="tel"
                            name="quantity"
                            className="form-control w-75 text-center"
                            value={item.quantity}
                            onChange={(e) =>
                              handleTableRowChange(
                                item.id,
                                "quantity",
                                e.target.value
                              )
                            }
                            style={{ width: "60px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="free_qty"
                            className="form-control"
                            value={item.free_qty}
                            onChange={(e) =>
                              handleTableRowChange(
                                item.id,
                                "free_qty",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            name="purchase_price"
                            className="form-control"
                            value={item.purchase_price}
                            onChange={(e) =>
                              handleTableRowChange(
                                item.id,
                                "purchase_price",
                                e.target.value
                              )
                            }
                          />
                        </td>
                        <td>
                          {(
                            ((parseFloat(item.quantity) || 0) *
                              (parseFloat(item.purchase_price) || 0) *
                              (parseFloat(item.discount_per_tablet) || 0)) /
                            100
                          ).toFixed(2)}
                        </td>
                        <td>{item.tax}</td>
                        <td>{item.total}</td>
                        <td className="text-center d-flex justify-content-center">
                          <button
                            className="btn btn-sm p-1 border-0"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => removeFromTable(item.id)}
                          >
                            <Trash size={16} className="text-danger" />
                          </button>
                          <button
                            className="btn btn-sm p-1 border-0"
                            style={{ backgroundColor: "transparent" }}
                            onClick={() => editTableRow(item)}
                          >
                            <Edit size={16} className="text-primary" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-lg-3">
            <div className="card card-body mb-2">
              <div className="row mb-2">
                <label className="col-4 col-form-label fw-bold">
                  Sub Total
                </label>
                <div className="col-8">
                  <input
                    type="text"
                    className="form-control text-end"
                    value={purchaseInfo.sub_total}
                    readOnly
                  />
                </div>
              </div>

              <div className="row align-items-center">
                <label className="col-4 col-form-label fw-bold">Discount</label>
                <div className="col-8 d-flex gap-2">
                  <input
                    type="number"
                    className="form-control"
                    name="discount_percentage"
                    value={purchaseInfo.discount_percentage}
                    onChange={handlePurchaseInfoChange}
                    placeholder="%"
                  />
                  <input
                    type="text"
                    className="form-control text-end"
                    value={purchaseInfo.discount_value}
                    readOnly
                    placeholder="Amount"
                  />
                </div>
              </div>

              <div className="row mb-3 align-items-center">
                <label className="col-4 col-form-label fw-bold">GST</label>
                <div className="col-8">
                  <input
                    type="text"
                    className="form-control text-end"
                    name="gst_amount"
                    value={purchaseInfo.gst_amount}
                    readOnly
                    placeholder="Amount"
                  />
                </div>
              </div>

              <div className="row mb-3 align-items-center">
                <label className="col-4 col-form-label fw-bold">Round Off</label>
                <div className="col-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="auto_round"
                    checked={isAutoRound}
                    onChange={handlePurchaseInfoChange}
                  />
                </div>
                <div className="col-6">
                  <input
                    type="tel"
                    className="form-control text-end"
                    name="round_off"
                    value={purchaseInfo.round_off}
                    onChange={handlePurchaseInfoChange}
                    placeholder="Round Off"
                    readOnly={isAutoRound}
                    disabled
                  />
                </div>
              </div>

              <div style={{ backgroundColor: "#01AEBE" }}>
                <div className="row pt-3 pb-0 p-2">
                  <label className="col-5 fs-5 col-form-label pt-3 text-white fw-bold">
                    Net Total
                  </label>
                  <div className="col-7">
                    <input
                      type="text"
                      className="form-control text-end fs-4 fw-bold text-primary"
                      value={purchaseInfo.net_total}
                      readOnly
                    />
                  </div>
                </div>
              </div>

              <div className="row mt-3 align-items-center">
                <label className="col-4 col-form-label fw-bold">Credits</label>
                <div className="col-2">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="credit"
                    checked={isCredit}
                    onChange={handlePurchaseInfoChange}
                  />
                </div>
                <div className="col-6">
                  <input
                    type="text"
                    className="form-control"
                    name="credit_days"
                    value={purchaseInfo.credit_days}
                    onChange={handlePurchaseInfoChange}
                    placeholder="Credit Days"
                    disabled={!isCredit}
                  />
                </div>
              </div>

              {!isCredit && (
                <div className="row d-flex justify-content-center mb-3">
                  <button
                    className="btn btn-md fw-bold btn-success w-75"
                    onClick={openModal}
                    disabled={
                      !purchaseInfo.invoice_number ||
                      !purchaseInfo.supplier_id ||
                      tableData.length === 0
                    }
                  >
                    + Add Payment
                  </button>
                </div>
              )}

              <div className="row align-items-center">
                <label className="col-4 col-form-label fw-bold">Paid</label>
                <div className="col-8">
                  <input
                    type="text"
                    className="form-control text-end"
                    value={purchaseInfo.paid}
                    readOnly
                  />
                </div>
              </div>

              <div className="row">
                <label className="col-4 col-form-label fw-bold">Balance</label>
                <div className="col-8">
                  <input
                    type="text"
                    className="form-control text-end"
                    value={purchaseInfo.balance}
                    readOnly
                  />
                </div>
              </div>

              <div className="row">
                <label className="col-4 col-form-label fw-bold">Notes</label>
                <div className="col-8">
                  <textarea
                    className="form-control"
                    name="notes"
                    value={purchaseInfo.notes}
                    onChange={handlePurchaseInfoChange}
                    rows="2"
                  ></textarea>
                </div>
              </div>

              <div className="row text-center">
                <div className="col-4">
                  <button
                    className="btn btn-sm btn-secondary w-100"
                    onClick={handleClearOverAll}
                  >
                    Clear
                  </button>
                </div>
                <div className="col-4">
                  <button
                    className="btn btn-sm btn-success w-100"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
                <div className="col-4">
                  <button
                    className="btn btn-sm btn-danger w-100"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade ${showAddModal ? "show" : ""}`}
          style={{ display: showAddModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addMedicineModalLabel"
          aria-hidden={!showAddModal}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header" style={{ borderBottom: "none" }}>
                <h6
                  className="modal-title text-dark"
                  id="addMedicineModalLabel"
                >
                  Add Medicine
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  style={{ fontSize: "10px" }}
                  onClick={closeAddModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleAddSubmit}>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="category" className="form-label">
                          Category
                        </label>
                        <select
                          className="form-select"
                          id="category"
                          name="category"
                          value={addData.category}
                          onChange={handleAddInputChange}
                          required
                        >
                          <option value="">Select Category</option>
                          <option value="Yoga">Yoga</option>
                          <option value="Homeopathy">Homeopathy</option>
                          <option value="General">General</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="hsn_code" className="form-label">
                          HSN Code
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="hsn_code"
                          name="hsn_code"
                          placeholder="Enter HSN Code"
                          value={addData.hsn_code}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="medicine_name" className="form-label">
                          Medicine
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="medicine_name"
                          name="medicine_name"
                          placeholder="Enter Medicine Name"
                          value={addData.medicine_name}
                          onChange={handleAddInputChange}
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="medicine_type" className="form-label">
                          Medicine Type
                        </label>
                        <select
                          className="form-control"
                          id="medicine_type"
                          name="medicine_type"
                          value={addData.medicine_type}
                          onChange={handleAddInputChange}
                          required
                        >
                          <option value="">Select Type</option>
                          <option value="Tablet">Tablet</option>
                          <option value="Capsule">Capsule</option>
                          <option value="Syrup">Syrup</option>
                          <option value="Injection">Injection</option>
                          <option value="Powder">Powder</option>
                          <option value="Sachet">Sachet</option>
                          <option value="Cream">Cream</option>
                          <option value="Ointment">Ointment</option>
                          <option value="Gel">Gel</option>
                          <option value="Drops">Drops</option>
                          <option value="Inhaler">Inhaler</option>
                          <option value="Suppository">Suppository</option>
                          <option value="Suspension">Suspension</option>
                          <option value="Spray">Spray</option>
                          <option value="Lotion">Lotion</option>
                          <option value="Solution">Solution</option>
                          <option value="Patch">Patch</option>
                          <option value="Dispersible Tablet">
                            Dispersible Tablet
                          </option>
                          <option value="Chewable Tablet">
                            Chewable Tablet
                          </option>
                          <option value="IV Fluid">IV Fluid</option>
                        </select>
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="manufacturer" className="form-label">
                          Manufacturer
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="manufacturer"
                          name="manufacturer"
                          placeholder="Enter Manufacturer"
                          value={addData.manufacturer}
                          onChange={handleAddInputChange}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="mb-3">
                        <label htmlFor="notes" className="form-label">
                          Notes
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="notes"
                          name="notes"
                          placeholder="Enter Notes"
                          value={addData.notes}
                          onChange={handleAddInputChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="text-center mt-4">
                    <button
                      type="submit"
                      className="btn btn-custom btn-sm px-4"
                      disabled={loading}
                      style={{ backgroundColor: "#01AEBE", border: "none" }}
                    >
                      {loading ? "Adding..." : "Submit"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div
          className={`modal fade ${paymentModal ? "show" : ""}`}
          style={{ display: paymentModal ? "block" : "none" }}
          tabIndex="-1"
          aria-labelledby="addPaymentModalLabel"
          aria-hidden={!paymentModal}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content rounded-3 shadow">
              <div className="modal-header bg-light">
                <h6
                  className="modal-title text-dark fw-bold"
                  id="addPaymentModalLabel"
                >
                  Add Payment
                </h6>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body">
                <div className="row g-3 mb-4">
                  {[
                    { label: "Total", value: purchaseInfo.net_total },
                    { label: "Paid", value: purchaseInfo.paid },
                    { label: "Balance", value: purchaseInfo.balance },
                  ].map((item, idx) => (
                    <div className="col-lg-4" key={idx}>
                      <label className="form-label fw-semibold">
                        {item.label}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        value={item.value}
                        disabled
                      />
                    </div>
                  ))}
                </div>

                <div className="row g-3 mb-4">
                  <div className="col-lg-3">
                    <label className="form-label fw-semibold">Date</label>
                    <input
                      className="form-control"
                      type="date"
                      name="paid_date"
                      value={paymentData.paid_date}
                      onChange={handlePaymentInputChange}
                    />
                  </div>

                  <div className="col-lg-3">
                    <label className="form-label fw-semibold">Pay Type</label>
                    <select
                      className="form-select"
                      name="pay_type"
                      value={paymentData.pay_type}
                      onChange={handlePaymentInputChange}
                    >
                      <option value="">Select Pay Type</option>
                      <option value="Cash">Cash</option>
                      <option value="Gpay">Gpay</option>
                      <option value="Paytm">Paytm</option>
                      <option value="Phonepe">Phonepe</option>
                      <option value="Credit">Credit</option>
                      <option value="Debit">Debit</option>
                    </select>
                  </div>

                  {paymentData.pay_type === "Credit" && (
                    <div className="col-lg-2">
                      <label className="form-label">Credit Days</label>
                      <input
                        className="form-control"
                        name="credit_days"
                        value={paymentData.credit_days}
                        onChange={handlePaymentInputChange}
                      />
                    </div>
                  )}

                  <div className="col-lg-3">
                    <label className="form-label fw-semibold">Paid Amount</label>
                    <input
                      className="form-control"
                      type="tel"
                      name="paid_amount"
                      value={paymentData.paid_amount}
                      onChange={handlePaymentInputChange}
                      placeholder="Enter Amount"
                    />
                  </div>

                  <div className="col-lg-1 text-end d-flex align-items-center mt-4">
                    <button
                      className="btn btn-success"
                      onClick={addPaymentToTable}
                    >
                      +
                    </button>
                  </div>
                </div>

                <div className="card shadow-sm">
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table className="table table-striped mb-0">
                        <thead
                          className="bg-teal text-white"
                          style={{ backgroundColor: "#01AEBE" }}
                        >
                          <tr>
                            <th className="py-2">S.No</th>
                            <th>Paid Date</th>
                            <th>Pay Type</th>
                            <th>Amount</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {paymentTableData.map((payment, index) => (
                            <tr key={payment.id}>
                              <td>{index + 1}</td>
                              <td>{payment.paid_date}</td>
                              <td>{payment.pay_type}</td>
                              <td>{payment.paid_amount}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <button
                                    className="btn btn-outline-danger btn-sm"
                                    onClick={() =>
                                      removePaymentFromTable(payment.id)
                                    }
                                  >
                                    <Trash size={16} />
                                  </button>
                                  <button
                                    className="btn btn-outline-primary btn-sm"
                                    disabled
                                  >
                                    <Edit size={16} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                          {paymentTableData.length === 0 && (
                            <tr>
                              <td
                                colSpan="5"
                                className="text-center text-muted py-3"
                              >
                                No payments added yet.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-primary px-5"
                    style={{ backgroundColor: "#01AEBE", border: "none" }}
                    onClick={handlePaymentSubmit}
                  >
                    Submit Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {paymentModal && <div className="modal-backdrop fade show"></div>}
        {showAddModal && <div className="modal-backdrop fade show"></div>}
      </div>
    </>
  );
}

export default AddPurchasePharmacy;